import { insertSkillMentionNode } from '#pplx/frontend/apps/ask/skills/insertSkillMentionNode.js';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
export function useAskInputSkills({ showSkills, lexicalEditorRef, collectionUuid, prefixWithSlash, replaceActiveCommandQuery, }) {
    const intl = useIntl();
    const onSkillSelect = useCallback((skill) => {
        const editor = lexicalEditorRef?.current;
        if (!editor) {
            return;
        }
        const options = {
            ...(prefixWithSlash === undefined ? {} : { prefixWithSlash }),
        };
        if (replaceActiveCommandQuery) {
            insertSkillMentionNode(editor, skill, intl, {
                ...options,
                replaceActiveCommandQuery: true,
            });
            return;
        }
        insertSkillMentionNode(editor, skill, intl, options);
    }, [intl, lexicalEditorRef, prefixWithSlash, replaceActiveCommandQuery]);
    if (showSkills) {
        return { showSkills: true, onSkillSelect, collectionUuid };
    }
    return { showSkills: false };
}
//# sourceMappingURL=useAskInputSkills.js.map